import { useSnapshot } from 'valtio';
import { profileStore } from '../stores/profile.store';

export const useProfileStore = () => {
  const snap = useSnapshot(profileStore);

  return {
    profile: snap.profile,
    expertise: snap.expertise,
    isProfileLoading: snap.isProfileLoading,
    isExpertiseLoading: snap.isExpertiseLoading,
    isError: snap.isError,
    error: snap.error,
    isLoading: snap.isProfileLoading || snap.isExpertiseLoading,
    hasApproval: snap.profile?.approvalStatus === 'approved',
    isPending: snap.profile?.approvalStatus === 'pending',

    actions: {
      setProfile: profileStore.setProfile,
      setExpertise: profileStore.setExpertise,
      setProfileLoading: profileStore.setProfileLoading,
      setExpertiseLoading: profileStore.setExpertiseLoading,
      setError: profileStore.setError,
      reset: profileStore.reset,
    },
  };
};
